import Loadable from 'react-loadable';

import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const SelectOrgDashboardLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "userDashboard/SelectOrgDashboardLoadable" */
      './SelectOrgDashboard'
    ),
  loading: LoadableLoadingSection,
});
